<header>
    {{ title }}
</header>
<section>
    {{ text }}
</section>
<footer>
    <div mat-dialog-close class="button red">
        <span i18n>{{ cancelLabel }}</span>
    </div>
    <div class="button green" [mat-dialog-close]="true">
        <span i18n>{{ confirmLabel }}</span>
    </div>
</footer>
